import axios from "axios"
// import { axiosBaseHeadersConfig } from "./config"
import CryptoJS from "crypto-js"
import {Toast} from 'vant'
import {clearUserTokenStorage, get0sVersionTokenStorage, getUserTokenStorage} from "./token"
import store from '@/store'
import router from '@/router';
import { v4 as uuidv4 } from 'uuid';

/*请求参数*/
const requestConfig = {
  key: "bc37cc63-9d14-4013-8255-9168f24ceacd",
  secret: "imlaw1dmgbsj2cm9",
  iv: "cdkjytgsrj754921",
}

/*MD5加密*/
const getMD5 = (rawStr) => {
  //encrypt
  return CryptoJS.MD5(rawStr)
}

/*加密*/
export const cryptoEncrypt = (word) => {
  let key = requestConfig.secret
  let iv = requestConfig.iv

  key = CryptoJS.enc.Utf8.parse(key)
  iv = CryptoJS.enc.Utf8.parse(iv)

  /* let srcs = CryptoJS.enc.Utf8.parse(word);*/
  // 加密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）
  let encrypted = CryptoJS.AES.encrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  //返回base64
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

export const middlewareAxios = (baseUrl) => {
  const creatAxios = axios.create({
    baseURL: baseUrl,
  })
  creatAxios.interceptors.request.use(
    (config) => {
      // 默认为 wap：5
      // config.headers['osVersion'] = 5;
      config.headers['osVersion'] = config.headers['osVersion'] || get0sVersionTokenStorage()  ||8;
      config.headers['transformationPath'] = localStorage.getItem('transformationPath') ? JSON.parse(localStorage.getItem('transformationPath')) : 0
      // config.headers['osVersion'] = 8;//TODO:关乎活动页面此行删除

      console.log('store.getters.getAppHeaderInfo',store.getters.getAppHeaderInfo)
      if(store.getters.getAppHeaderInfo){
        Object.keys(store.getters.getAppHeaderInfo).forEach((key) => {
          if(key === 'city'){
            delete store.getters.getAppHeaderInfo[key]
          }
          config.headers[key] = store.getters.getAppHeaderInfo[key]
        })
      }
      // 2.3.1律师端单独处理 大数据要求此渠道写死9  2.5.4版本
      if( ['registerRegisterThree' ,'registerRegisterFour'].includes(router?.history?.current?.name)){
        config.headers['osVersion'] = 9
      }
      // 2.3.2律师端单独处理 案源详情分享页面TODO:
      if(router?.history?.current?.name === 'caseShareDetail'){
        if(!localStorage.getItem('changlv-h5-download-deviceId')){
            localStorage.setItem('changlv-h5-download-deviceId',uuidv4())
          }
          console.log('router:', router.history.current.query)
        // const { channelId, deviceId, messageType, messageCode} = router.history.current.query
        const { deviceId, messageType, messageCode} = router.history.current.query
        var axiosBaseHeadersConfigCase = {
            osVersion: '9',
            // platform: 'h5',
            // channelId,
            deviceId: deviceId || localStorage.getItem('changlv-h5-download-deviceId'),
            messageType,
            messageCode
        };
        Object.keys(axiosBaseHeadersConfigCase).forEach((key) => {
          config.headers[key] = axiosBaseHeadersConfigCase[key]
        })
        console.log('案源详情axiosBaseHeadersConfigCase:', axiosBaseHeadersConfigCase)
      }
      config.headers['token'] = getUserTokenStorage();
      /*deviceId补偿*/
      if(!config.headers["deviceId"]){
          let deviceId  = localStorage.getItem('changlv-h5-download-deviceId');
          if(!deviceId){
              deviceId = uuidv4()
              localStorage.setItem('changlv-h5-download-deviceId',deviceId)
          }
          config.headers["deviceId"] = deviceId
      }

      /*post 需要验签*/
      if (config.method === "post") {
        config.headers["Content-Type"] =
          config.headers["Content-Type"] || "application/x-www-form-urlencoded"
        const params = config.data
          console.log('axios.params',params)
        // 数据+签名加密
        const base64 = params
          ? encodeURI(cryptoEncrypt(JSON.stringify(params)))
          : ""
        const sign = getMD5(`${base64}${requestConfig.key}`)
        config.headers["sign"] = sign
        if (params) {
          config.data = "data=" + base64
        }
        console.log('config.data',config.data)
        return config
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
  creatAxios.interceptors.response.use(
    (response) => {
        console.log(response.config.url,response.config.data)
      const responseData = response.data
      /*  if (process.env.NUXT_ENV_SERVER_TYPE === 'development') {
        console.log(response.config.url, responseData);
      }*/
      if (responseData.code === 0) return response.data
      else if (responseData.code === 401) {
        Toast('登录失效，请重新登录')
        clearUserTokenStorage()
      } else {
        Toast(responseData.message)
      }
      return Promise.reject(response)
    },
    (error) => {
      return Promise.reject(error)
    }
  )
  return creatAxios
}
// 开发时跨域使用 发测试正式用 VUE_APP_ENV_BASE_URL
// const corseBaseUrl = process.env.VUE_APP_ENV_SERVER_TYPE === 'development' ? '/testapi' : process.env.VUE_APP_ENV_BASE_URL
export const requestParalegal = middlewareAxios(
  process.env.VUE_APP_ENV_BASE_URL + process.env.VUE_APP_ENV_SEVER_ROUTE_PARALEGAL
)

export const requestOrder = middlewareAxios(
  process.env.VUE_APP_ENV_BASE_URL + process.env.VUE_APP_ENV_SEVER_ROUTE_ORDER
)

export const requestInfo = middlewareAxios(
  process.env.VUE_APP_ENV_BASE_URL + process.env.VUE_APP_ENV_SEVER_ROUTE_INFO
)

export const requestCore = middlewareAxios(
  process.env.VUE_APP_ENV_BASE_URL + process.env.VUE_APP_ENV_SEVER_ROUTE_CORE
)

export const requestCms = middlewareAxios(
  process.env.VUE_APP_ENV_BASE_URL + process.env.VUE_APP_ENV_SEVER_ROUTE_CMS
)

export const requestCommon = middlewareAxios(process.env.VUE_APP_ENV_BASE_URL)
